var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudswiththunder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 245,
    viewBox: "0 0 285 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.38 143.314L106.832 190.588C105.802 192.355 107.085 194.56 109.122 194.56H118.08C118.58 194.56 118.884 195.091 118.647 195.515L94.3492 239.056C92.8698 241.707 96.2715 244.307 98.4631 242.281L167.327 178.624C169.1 176.985 167.929 174.042 165.528 174.042H156.521C156.017 174.042 155.713 173.502 155.958 173.078L171.643 145.965C172.665 144.198 171.382 142 169.349 142H136.67C135.728 142 134.855 142.5 134.38 143.314Z",
    fill: "url(#paint0_linear_107_1536)",
    stroke: "url(#paint1_linear_107_1536)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.7664,
    y: 191.774,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 73.7664 191.774)",
    fill: "url(#paint2_linear_107_1536)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.7664,
    y: 191.774,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 42.7664 191.774)",
    fill: "url(#paint3_linear_107_1536)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.4436,
    y: 143,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 95.4436 143)",
    fill: "url(#paint4_linear_107_1536)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4436,
    y: 143,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 64.4436 143)",
    fill: "url(#paint5_linear_107_1536)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 172.766,
    y: 191.774,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 172.766 191.774)",
    fill: "url(#paint6_linear_107_1536)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 204.23,
    y: 191.774,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 204.23 191.774)",
    fill: "url(#paint7_linear_107_1536)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 194.444,
    y: 143,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 194.444 143)",
    fill: "url(#paint8_linear_107_1536)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 225.908,
    y: 143,
    width: 12.1935,
    height: 33.8707,
    rx: 6.09673,
    transform: "rotate(15 225.908 143)",
    fill: "url(#paint9_linear_107_1536)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_107_1536)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-1_107_1536",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 11,
    width: 255,
    height: 155,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 15,
    y: 11,
    width: 255,
    height: 155
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.882 82.0141C197.882 84.4233 197.758 86.8036 197.517 89.149C204.953 82.6871 214.664 78.7752 225.288 78.7752C248.68 78.7752 267.643 97.7383 267.643 121.13C267.643 144.523 248.68 163.486 225.288 163.486H60.6379C60.6256 163.486 60.6133 163.486 60.601 163.486C60.5887 163.486 60.5764 163.486 60.5641 163.486H60.3518V163.485C36.3863 163.351 17 143.882 17 119.885C17 95.9758 36.2441 76.5617 60.0878 76.2867C62.999 40.8508 92.6809 13 128.868 13C166.983 13 197.882 43.8987 197.882 82.0141Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.882 82.0141C197.882 84.4233 197.758 86.8036 197.517 89.149C204.953 82.6871 214.664 78.7752 225.288 78.7752C248.68 78.7752 267.643 97.7383 267.643 121.13C267.643 144.523 248.68 163.486 225.288 163.486H60.6379C60.6256 163.486 60.6133 163.486 60.601 163.486C60.5887 163.486 60.5764 163.486 60.5641 163.486H60.3518V163.485C36.3863 163.351 17 143.882 17 119.885C17 95.9758 36.2441 76.5617 60.0878 76.2867C62.999 40.8508 92.6809 13 128.868 13C166.983 13 197.882 43.8987 197.882 82.0141Z",
    fill: "url(#paint10_linear_107_1536)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.517 89.149L195.528 88.9447L195.011 93.9771L198.829 90.6586L197.517 89.149ZM60.3518 163.486H58.3518V165.486H60.3518V163.486ZM60.3518 163.485H62.3518V161.496L60.363 161.485L60.3518 163.485ZM60.0878 76.2867L60.1109 78.2866L61.932 78.2655L62.0811 76.4504L60.0878 76.2867ZM199.507 89.3534C199.755 86.9401 199.882 84.4916 199.882 82.0141H195.882C195.882 84.3549 195.762 86.667 195.528 88.9447L199.507 89.3534ZM225.288 76.7752C214.163 76.7752 203.991 80.8733 196.206 87.6395L198.829 90.6586C205.915 84.5008 215.164 80.7752 225.288 80.7752V76.7752ZM269.643 121.13C269.643 96.6337 249.785 76.7752 225.288 76.7752V80.7752C247.576 80.7752 265.643 98.8429 265.643 121.13H269.643ZM225.288 165.486C249.785 165.486 269.643 145.627 269.643 121.13H265.643C265.643 143.418 247.576 161.486 225.288 161.486V165.486ZM225.288 161.486H60.6379V165.486H225.288V161.486ZM60.601 165.486C60.6079 165.486 60.6146 165.486 60.6207 165.486C60.6269 165.486 60.6324 165.486 60.6379 165.486V161.486C60.631 161.486 60.6242 161.486 60.6182 161.486C60.6119 161.486 60.6064 161.486 60.601 161.486V165.486ZM60.5641 165.486C60.5695 165.486 60.5751 165.486 60.5813 165.486C60.5873 165.486 60.5941 165.486 60.601 165.486V161.486C60.5956 161.486 60.59 161.486 60.5838 161.486C60.5778 161.486 60.571 161.486 60.5641 161.486V165.486ZM60.5641 161.486H60.3518V165.486H60.5641V161.486ZM62.3518 163.486V163.485H58.3518V163.486H62.3518ZM15 119.885C15 144.983 35.2756 165.345 60.3407 165.485L60.363 161.485C37.4971 161.357 19 142.781 19 119.885H15ZM60.0647 74.2868C35.1268 74.5744 15 94.879 15 119.885H19C19 97.0727 37.3614 78.5489 60.1109 78.2866L60.0647 74.2868ZM128.868 11C91.6312 11 61.0902 39.6581 58.0945 76.1229L62.0811 76.4504C64.9077 42.0436 93.7306 15 128.868 15V11ZM199.882 82.0141C199.882 42.7941 168.088 11 128.868 11V15C165.879 15 195.882 45.0033 195.882 82.0141H199.882Z",
    fill: "url(#paint11_linear_107_1536)",
    mask: "url(#path-10-outside-1_107_1536)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_107_1536)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.882 82.0141C197.882 84.4233 197.758 86.8036 197.517 89.1491C204.953 82.6871 214.664 78.7752 225.288 78.7752C248.68 78.7752 267.643 97.7383 267.643 121.13C267.643 144.523 248.68 163.486 225.288 163.486C225.276 163.486 225.264 163.486 225.252 163.486H60.601H60.3518V163.485C36.3863 163.351 17 143.882 17 119.885C17 95.9758 36.2441 76.5617 60.0878 76.2867C62.999 40.8508 92.6809 13 128.868 13C166.983 13 197.882 43.8987 197.882 82.0141Z",
    fill: "url(#paint12_linear_107_1536)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_107_1536",
    x: 0,
    y: 0,
    width: 284.643,
    height: 184.486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_107_1536"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_107_1536",
    result: "effect2_dropShadow_107_1536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_107_1536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_107_1536",
    x: 2,
    y: 2,
    width: 280.643,
    height: 180.486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_107_1536"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_107_1536",
    result: "effect2_dropShadow_107_1536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_107_1536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_1536",
    x1: 152.406,
    y1: 150.541,
    x2: 95.7515,
    y2: 233.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182844,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980542,
    stopColor: "#F09000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_1536",
    x1: 113.264,
    y1: 114.656,
    x2: 153.831,
    y2: 283.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14688,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938214,
    stopColor: "#F09000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_1536",
    x1: 75.1212,
    y1: 221.58,
    x2: 85.9598,
    y2: 195.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_1536",
    x1: 44.1212,
    y1: 221.58,
    x2: 54.9598,
    y2: 195.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_107_1536",
    x1: 96.7984,
    y1: 172.806,
    x2: 107.637,
    y2: 147.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_1536",
    x1: 65.7984,
    y1: 172.806,
    x2: 76.6371,
    y2: 147.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_107_1536",
    x1: 174.121,
    y1: 221.58,
    x2: 184.96,
    y2: 195.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_107_1536",
    x1: 205.585,
    y1: 221.58,
    x2: 216.424,
    y2: 195.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_107_1536",
    x1: 195.798,
    y1: 172.806,
    x2: 206.637,
    y2: 147.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_107_1536",
    x1: 227.263,
    y1: 172.806,
    x2: 238.101,
    y2: 147.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3981EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_107_1536",
    x1: 96.5248,
    y1: 28.5,
    x2: 176.025,
    y2: 158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#508ABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2073A2",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_107_1536",
    x1: 177.525,
    y1: 213.5,
    x2: 99.5247,
    y2: -6.49999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4195C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E8398",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE2FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_107_1536",
    x1: 176.025,
    y1: 216.5,
    x2: 176.025,
    y2: 128.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudswiththunder);
export default __webpack_public_path__ + "static/media/Clouds with thunder.37ed172e1fcfbc92256e60f2d040656d.svg";
export { ForwardRef as ReactComponent };